import { render, staticRenderFns } from "./TransaksiPerusahaan.vue?vue&type=template&id=9de772d0&scoped=true"
import script from "./TransaksiPerusahaan.vue?vue&type=script&lang=js"
export * from "./TransaksiPerusahaan.vue?vue&type=script&lang=js"
import style0 from "./TransaksiPerusahaan.vue?vue&type=style&index=0&id=9de772d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de772d0",
  null
  
)

export default component.exports